export function useStatamicPreviewMode() {
  const route = useRoute()
  return usePreviewMode({
    shouldEnable: () => {
      return !!route.query['live-preview']
    },
  })
}
